import React, { useState } from 'react';

import TabNavigator from '../tabNavigator';
import MarketDashboard from './tabs/marketDashboard';
import MarketResearch from './tabs/marketResearch';

export const RealEstateMarketTabNames = {
    Dashboard: 'Dashboard',
    Research: 'Research',
};

function RealEstateMarketTabs() {
    const [selectedTab, setSelectedTab] = useState(
        RealEstateMarketTabNames.Dashboard,
    );

    const selectTab = (tab) => setSelectedTab(tab);

    const tabs = RealEstateMarketTabNames;

    const getTabContentsComponent = () => {
        return (
            <>
                <div
                    className={
                        selectedTab === RealEstateMarketTabNames.Dashboard
                            ? 'd-block'
                            : 'visually-hidden'
                    }
                >
                    <MarketDashboard />
                </div>
                <div
                    className={
                        selectedTab === RealEstateMarketTabNames.Research
                            ? 'd-block'
                            : 'visually-hidden'
                    }
                >
                    <MarketResearch />
                </div>
            </>
        );
    };

    return (
        <>
            <div className="col-12">
                <TabNavigator selected={selectedTab} onSelect={selectTab} tabs={tabs} />
            </div>
            <div className="mt-4" style={{ maxWidth: '1475px' }}>
                {getTabContentsComponent()}
            </div>
        </>
    );
}
export default RealEstateMarketTabs;
